module.exports = __webpack_public_path__ + "img/背景底图.c6216b75.png";